import { summaryModel } from "../summary.model";
// import { DataSource, Service, QuotationStatus } from "./quotation.model";
import { EditOfficeModel } from "../office/edit-officemodel";
import { BehaviorSubject } from "rxjs";
import { SupplierDataSourceRequest } from "../common/common.model";
import { AttachmentFile } from "../fileupload/fileupload";
import { array } from "@amcharts/amcharts4/core";
export class QuotationNewsummarymodel extends summaryModel {

  public supplierid: number = 0;
  public factoryidlst: number[] = [];
  public datetypeid: number;
  public fromdate: any = null;
  public todate: any = null;
  public serviceTypelst: number[] = [];
  public dateTerm: any = null;
  public bookingNo: string = "";
  public statusidlst: number[] = [];
  public customerContactId: number;

  constructor() {
    super();

    this.supplierid = 0;
    this.factoryidlst = [];
    this.fromdate = null;
    this.todate = null;
    this.serviceTypelst = [];
    this.dateTerm = null;
    this.bookingNo = "";
    this.statusidlst = [];
  }

}

export class QuotationNewItem {
  public isSelected: boolean;
  public bookingNo: string;
  public supplierName: string;
  public serviceType: string;
  public product: Array<string>;
  public serviceId: number;
  public serviceIcon: string;
  public  supplierId: number;
  public inspectionResponsible: number;
}



export interface QuotationNewDataSummaryResponse {
  data: Array<QuotationNewItem>;
  result: QuotationNewDataSummaryResult;
  totalCount: number;
  index: number;
  pageSize: number;
  pageCount: number;
}

export enum QuotationNewDataSummaryResult {
  Success = 1,
  NotFound = 2
}



export class QuotationNewMasterModel {

  supsearchRequest: SupplierDataSourceRequest;
  supInput: BehaviorSubject<string>;
  supLoading: boolean;
  public supplierList: any;

  facsearchRequest: SupplierDataSourceRequest;
  facInput: BehaviorSubject<string>;
  facLoading: boolean;
  public factoryList: any;
  serviceTypeList: any;
  serviceTypeLoading: any;
  selectedDate: string;
  selectedNumber: string;
  selectedNumberPlaceHolder: string;
  isShowColumn: boolean;
  isShowColumnImagePath: string;
  showColumnTooltip: string;
  isShowSearchLens: boolean;
  statusList: any;
  pageLoader: boolean;
  supplierName: string;
  customerName: string;
  factoryNameList: Array<string>;
  countryNameList: Array<string>;
  statusNameList: Array<string>;
  DateName: string;
  editButtonVisible: boolean;
  confirmButtonVisible: boolean;
  cancelButtonVisible: boolean;
  rescheduleButtonVisible: boolean;
  combineButtonVisible: boolean;
  splitButtonVisible: boolean;
  inspectionCompanyLoading: boolean;
  inspectionCompanyList: any;
  defaultStartDate: number;
  defaultEndDate: number;
  canUpdateBooking: boolean;
  lblDateRangeToDisplay: string;
  customerId: number;
  searchloading: boolean;
  constructor() {
    this.pageLoader = false;
    this.isShowColumn = true;
    this.supInput = new BehaviorSubject<string>("");
    this.facInput = new BehaviorSubject<string>("");
    this.supsearchRequest = new SupplierDataSourceRequest();
    this.facsearchRequest = new SupplierDataSourceRequest();
  }


}

export class QuotationUploadedSummaryResponse {
  data: QuotationSummaryUploaded[];
  quotationStatuslst: QuotationStatus[];
  quotationServices: [];
  result: QuotationUploadedSummaryResult;
  totalCount: number = 0;
  index: number;
  pageSize: number;
  pageCount: number;
}

export enum QuotationUploadedSummaryResult {
  Success = 1,
  NotFound = 2,
  NoBookingNo = 3
}

export class QuotationSummaryUploaded {
  quotationId: number;
  statusId: number;
  statusText: string;
  serviceId: number;
  comment: string;
  quotationFileName: string;
  quotationFileUrl: string;
  uploadedByImage: string;
  uploadedBy: string;
  uploadedOn?: string | null;   // DateTime? → string or null
  isHasSupportingDocuments: boolean;
  bookingData: QuotationServiceItem[];
  isExpanded?: boolean;
  fileName?: string;
  id: number;
  invoiceFileUrl:string;
  IsContactTypeAdded  : boolean;
}

export class QuotationServiceItem {
  quotationId: number;
  bookingNo: string;
  supplierName: string;
  serviceType: string;
  product: string[];
  serviceIcon?: string;
  showProducts?: boolean;
}

export class QuotationFileAttachmentData {
  id?: number;
  labBookingId?: number;
  category?: number;
  description?: string;
  uniqueId?: string;
  fileName?: string;
  fileUrl?: string;
  certificateId?: number | null;
  showUploadBtnLoader: boolean;
  FileData: AttachmentFile;
  Certificatename: string;
  CertificteTypeName: String;
}

export class QuotationStatus {
  id: number;
  statusId: number;
  statusName: string;
  statusColor: string;
  statusImage: string;
  totalCount: number;
  statusActive: boolean;
}

export class QuotationHistoryResponse {
  quotationId: number;
  comment: string | null;
  updatedOn: string;           // DateTime → string (or Date if you prefer)
  updatedBy: string;
  updateByImage: string;
  statusId?: number | null;    // nullable in C#
  isQuotationReuploaded: boolean;
  quotatonFileUrl: string;
  bookingNo: Array<string>;
}

export class QuotationChangeStatusRequest {
  quotationId: number;
  statusId: number;
  comment: string;
}

export enum QuotationStatusUpdateResponseStatus {
  Success = 1,
  QuotationNotExists = 2,
  StatusAlreadySame = 3,
  Error = 4
}

export enum QuotationStatusMaster {
  DecisionPending = 1,
  Rejected = 2,
  Approved = 3
}
